import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsConditionsPage } from './pages/TermsConditionsPage';
import { SmsTermsPage } from './pages/SmsTermsPage';
import { ContactPage } from './pages/ContactPage';
// Set title immediately at module load (before React renders)
document.title = 'Deluxe MedSpa Beauty | Luxury Medical Spa in Miami';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-brand-black font-body text-brand-champagne-light selection:bg-brand-gold selection:text-brand-black" data-id="element-2">
        <Navigation data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-9" />} data-id="element-8" />
            <Route path="/terms-conditions" element={<TermsConditionsPage data-id="element-11" />} data-id="element-10" />
            <Route path="/sms-terms" element={<SmsTermsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
          </Routes>
        </div>
        <Footer data-id="element-16" />
      </div>
    </BrowserRouter>;
}